import { Component, EventEmitter, Inject, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TagAcquisitionModel } from 'src/app/models/acquisition/TagAcquisitionModel';
import { UnitAcquisitionStateModel } from 'src/app/models/acquisition/UnitAcquisitionStateModel';
import { UnitAcquisitionUpdateModel } from 'src/app/models/acquisition/UnitAcquisitionUpdateModel';
import { UiLoadingModel } from 'src/app/tinea-components/loading/models/UiLoadingModel';
import { environment } from 'src/environments/environment';
import { UnitAcquisitionState, UnitAcquisitionUpdate } from 'src/swagger-gen/web-secured/models';

@Component({
    selector: 'app-modal-unit-acquisition-parameters',
    templateUrl: './modal-unit-acquisition-parameters.component.html',
    styleUrls: ['./modal-unit-acquisition-parameters.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ModalUnitAcquisitionParametersComponent implements OnInit {

  @Output() submitted: EventEmitter<UnitAcquisitionUpdate[]> = new EventEmitter();

  deviantTagsAcquisition: TagAcquisitionModel[] = [];

  form: UntypedFormGroup = this.fb.group({
    units: this.fb.array([])
  });
  get u(): UntypedFormArray {return this.form.controls.units as UntypedFormArray}

  spinner = new UiLoadingModel();

  constructor(
    private fb: UntypedFormBuilder,
    @Inject(MAT_DIALOG_DATA) public unitsAcquisitionStates: UnitAcquisitionStateModel[]
  ) {}

  ngOnInit(): void {
    this.form.controls.units = this.createForm(this.unitsAcquisitionStates, this.u);
  }

  /**************************************/
  /**********FORM CREATION***************/
  /**************************************/

  createForm(units: UnitAcquisitionState[], form: UntypedFormArray): UntypedFormArray{
    units.forEach((unit: UnitAcquisitionState) => {
      form.push(this.createUnitFormGroup(unit));
    })
    return form;
  }

  createUnitFormGroup(unit: UnitAcquisitionState): UntypedFormGroup{
    return this.fb.group({
      name: [unit.name],
      uid: [unit.uid],
      specialAcquisitionCount: [unit.specialAcquisitionCount],
      delta: [unit.delta, Validators.pattern(environment.core.regexp.decimals)],
      period: [unit.period, Validators.pattern(environment.core.regexp.numbers)],
      excludeSpecials:[false]
    })
  }

  /*************************************************/
  /*******************FORM SUBMISSION***************/
  /*************************************************/

  submitForm(){
    let body: UnitAcquisitionUpdate[] = [];
    if(this.form.valid){
      this.u.controls.forEach((u: UntypedFormGroup) => {
        if(u.controls.delta.value && u.controls.period.value) body = this.addToBody(u, body);
      });
      this.submitted.emit(body);
    }
  }

  addToBody(unit: UntypedFormGroup, body: UnitAcquisitionUpdate[]): UnitAcquisitionUpdate[]{
    body.push(new UnitAcquisitionUpdateModel(unit));
    return body;
  }

  /*************************************************/
  /*******************DISPLAY***********************/
  /*************************************************/

  displaySpecialCount(uid: string): boolean{
    const unit = this.unitsAcquisitionStates.find((unit: UnitAcquisitionStateModel) => unit.uid === uid);
    if(unit === null) return false;
    return !!unit.delta && !!unit.period;
  }

}
